import React from 'react';
import { useUserData } from '../../hooks/useUserData';
import { PageSpinner } from '@td-client-frontend/common';

export const UserDetailsModal = ({ userId }) => {
  const { data: userData, isFetching } = useUserData({ userId });
  return (
    <div className="w-full h-full overflow-y-scroll p-6">
      {!isFetching ? (
        <div>
          <h2 className="font-bold">User details</h2>
          <div className="flex mt-6">
            <div className="w-1/3">
              <h3 className="font-bold">First name</h3>
              <hr className="mr-6 my-4" />
              <p className="">{userData?.firstNm}</p>
              <hr className="my-4" />
            </div>
            <div className="w-1/3">
              <h3 className="font-bold">Last name</h3>
              <hr className="mr-6 my-4" />
              <p>{userData?.lastNm}</p>
              <hr className="my-4" />
            </div>
            <div className="w-1/3">
              <h3 className="font-bold">Email address</h3>
              <hr className="my-4" />
              <p>{userData?.email[0].emailAddress}</p>
              <hr className="my-4" />
            </div>
          </div>

          <h2 className="font-bold mt-12">Organizations and Roles</h2>
          {userData?.permissions?.length && (
            <div className="flex mt-6 h-46 overflow-y-scroll">
              <div className="w-1/2">
                <h3 className="font-bold">Organization</h3>
                <hr className="mr-6 my-4" />
                {userData?.permissions.map(({ scope }) => (
                  <>
                    <p className="">{scope.name}</p>
                    <hr className="my-4" />
                  </>
                ))}
              </div>
              <div className="w-1/2">
                <h3 className="font-bold">Role</h3>
                <hr className="my-4" />
                {userData?.permissions.map(({ role }) => (
                  <>
                    <p className="">{role.roleNm}</p>
                    <hr className="my-4" />
                  </>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <PageSpinner />
      )}
    </div>
  );
};
